<template>
  <div class="order-item"
       :class="{'order-item--done': isDone, 'order-item--ready': item.ready_at, 'order-item--cancelled': item.cancelled_at, 'order-item--disabled': disabled}"
       @click="toggleDone(item.id)"
       :style="itemStyles">
    <div class="md-layout">
      <div class="md-layout-item order-item__amount md-size-15">
        <div>{{item.quantity}}</div>
      </div>
      <div class="md-layout-item">
        <div class="order-item__name">{{item.pos_text ?? item.name}}</div>
        <div class="order-item__quantity" v-if="!item.pos_text">{{item.subtitle}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "OrderItem",
  props: {
    item: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('dashboard', ['doneOrderItems']),
    isDone() {
      return this.doneOrderItems.includes(this.item.id);
    },
    itemStyles() {
      let styles = {}
      if (!this.isDone && this.item.pos_color) {
        styles.background = 'rgb(' + this.item.pos_color + ')'
      }
      return styles
    }
  },
  methods: {
    ...mapActions('dashboard', ['setOrderItemsDone', 'setOrderItemsUndone', "doneOrderItemsContains"]),
    toggleDone(id) {
      if (this.disabled) return;
      if (this.isDone) {
        this.setOrderItemsUndone(id)
      } else {
        this.setOrderItemsDone(id)
      }
    },
  }
}
</script>
